// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.0375 7.57319L16.4272 1.96289L12.2309 6.15922L17.8412 11.7695L22.0375 7.57319Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.427 13.1837L10.817 7.57373L1.99976 16.3904V22.0007L7.61005 22.0007L16.427 13.1837Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.6815 22.0007H22.2245V20.0007L12.6815 20.0007V22.0007Z"}}]};

const Edit2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'edit-2-filled',
    ref,
    icon: element,
  },
));

Edit2FilledIcon.displayName = 'Edit2FilledIcon';

export default Edit2FilledIcon;
